function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrash = function SvgTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    stroke: "currentColor",
    viewBox: "0 0 41.29 43.48",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "none",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeWidth: 2,
      strokeLinejoin: "round"
    },
    d: "M27.57,42.48H13.31A4.64,4.64,0,0,1,8.7,38.33L6.09,13.79H34.78l-2.6,24.54A4.64,4.64,0,0,1,27.57,42.48Z"
  }), React.createElement("line", {
    style: {
      fill: "none",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    x1: 14.39,
    y1: 18.36,
    x2: 15.7,
    y2: 37.92
  }), React.createElement("line", {
    style: {
      fill: "none",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    x1: 24.82,
    y1: 37.92,
    x2: 26.13,
    y2: 18.36
  }), React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeWidth: 2,
      strokeLinejoin: "round"
    },
    x: 1,
    y: 9.09,
    width: 39.29,
    height: 4.62,
    rx: 1
  }), React.createElement("path", {
    style: {
      fill: "none",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M12.86,9.09C13.12,4.56,16.51,1,20.64,1s7.53,3.56,7.79,8.09"
  }), React.createElement("path", {
    style: {
      fill: "none",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M16.51,9.09a4.4,4.4,0,0,1,4.13-4.23,4.41,4.41,0,0,1,4.14,4.23"
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash.6ef83149.svg";
export { ForwardRef as ReactComponent };